import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import { Card, Row } from 'react-bootstrap';

import IndicationItem from './IndicationItem';

import { emetIndications } from 'data/certifications/emetIndications';
import { epstIndications } from 'data/certifications/epstIndications';
import CertificationItem from './CertificationItem';



const Indications = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const certification = location.state; // Aquí obtienes el state que fue pasado desde <Link>
    const [indications, setIndications] = useState([]);

    useEffect(() => {
        // Si certification es null o undefined, redirigir al usuario a la página principal
        if (!certification) {
            navigate('/'); // Redirige a la ruta raíz "/"
        } else {
            if (certification.catalog_id === 1) {
                // Para EPST: Calcular el tiempo estimado
                const estimatedTime = certification.candidate_type === 1
                    ? epstIndications.estimatedTimeAdults
                    : epstIndications.estimatedTimeKids;

                setIndications(
                    epstIndications.indications.map((indication) => {
                        return {
                            ...indication,
                            description: indication.title === 'Tiempo estimado'
                                ? `El tiempo estimado para terminar esta certificación es: ${estimatedTime} minutos.`
                                : indication.description
                        };
                    })
                );
            } else {
                setIndications(emetIndications.indications);
            }
        }
    }, [certification, navigate]);

    if (!certification) {
        return null;
    }

	return (
		<>
			<Card className="mb-3">
				<Card.Header className="border-bottom border-200">
					<h6 className="mb-0">Indicaciones</h6>
				</Card.Header>
				<Card.Body>
					<Row className="gx-3">
                    {indications.map((indication, index) => (
                        <IndicationItem key={index} indication={indication} />
                    ))}
					</Row>
				</Card.Body>
			</Card>

			<Card>
				<Card.Header className="border-bottom border-200">
					<h6 className="mb-0">Empezar certificación</h6>
				</Card.Header>
				<Card.Body>
                    <CertificationItem cert={certification} />
				</Card.Body>
			</Card>
		</>
	);
};

export default Indications;
